import React from 'react';
import MessagingHub from './Messaging/MessagingHub';
import SuccessionPageLayout from './SuccessionPageLayout';
import SuccessionThemeProvider, { useSuccessionTheme } from './SuccessionThemeProvider';
import {
  CheckCircleIcon
} from '@heroicons/react/24/outline';

// Inner component that uses the theme context
const SuccessionMessagesContent = ({ current_user, company, features }) => {
  const { theme, isLightTheme, isDarkTheme } = useSuccessionTheme();
  
  // Check company features for messaging functionality
  const hasModernMessaging = features?.includes('findbob_modernization');
  const hasNewMessages = features?.includes('new_messages');
  const hasBlockingFeature = company?.allow_blocking_in_messages;
  const hasFileAttachments = features?.includes('file_attachments') || hasModernMessaging;

  // Helper functions for SuccessionPageLayout
  const getPageTitle = () => {
    return "Messages";
  };

  const getPageSubtitle = () => {
    return "Stay connected with your network and grow your practice";
  };

  const getActionButtons = () => {
    // Messages page typically doesn't have action buttons in the header
    // but could add features like "New Message" or "Settings" if needed
    return [];
  };

  return (
    <SuccessionPageLayout
      title=""
      subtitle=""
      actionButtons={getActionButtons()}
    >
      {/* Full-height messages container - use flex to ensure it fills available space */}
      <div className="h-full flex flex-col bg-succession-bg-primary border border-succession-border rounded-lg overflow-hidden transition-colors duration-300 shadow-succession-lg">
        <MessagingHub 
          currentUser={current_user}
          theme={isLightTheme ? 'light' : 'dark'}
        />
      </div>
    </SuccessionPageLayout>
  );
};

// Main component wrapper with theme provider
const SuccessionMessages = ({ current_user, company, features }) => {
  return (
    <SuccessionThemeProvider company={company} user={current_user}>
      <SuccessionMessagesContent 
        current_user={current_user} 
        company={company} 
        features={features}
      />
    </SuccessionThemeProvider>
  );
};

export default SuccessionMessages; 